export default function ReviewsSection() {
  const reviews = [
    {
      name: '心斎橋ホスト Aさん',
      role: 'ホスト',
      rating: 5,
      comment: 'シャンパンコールの時にLEDが光って、お客様が大喜びでした！自分の写真入りボトルは本当に特別感があって、SNSでもバズりました。リピート確定です！',
      avatar: 'https://public.readdy.ai/ai/img_res/edited_b420929b5e38e37e5b7d838e7c41f7bc_cfeca8f3.jpg',
    },
    {
      name: '北新地キャバ嬢 Mさん',
      role: 'キャバクラ嬢',
      rating: 5,
      comment: 'インスタ映えが最高です！お客様からの指名も増えて、オリシャンのおかげで売上がアップしました。デザインの相談も丁寧に対応してくれて安心でした。',
      avatar: 'https://public.readdy.ai/ai/img_res/edited_753c23f38818ce7c53115dc5f996f1bc_705c7092.jpg',
    },
    {
      name: '北新地BARオーナー Tさん',
      role: 'BARオーナー',
      rating: 5,
      comment: '店舗ロゴ入りのオリシャンを記念日に提供したら、VIPのお客様に大変喜ばれました。高級感があって、ブランディングにも最適です。納期も早くて助かりました。',
      avatar: 'https://public.readdy.ai/ai/img_res/edited_db699cd43fcbc5a25ddbee36986f13ae_19dc661b.jpg',
    },
  ];

  return (
    <section id="reviews" className="py-24 bg-gradient-to-b from-black to-purple-950/20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            お客様の声
          </h2>
          <p className="text-xl text-gray-300">
            多くの方にご満足いただいています
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {reviews.map((review, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-purple-900/30 to-black/50 rounded-3xl p-8 border border-purple-500/20 hover:border-yellow-400/50 transition-all duration-500 hover:scale-105 cursor-pointer"
            >
              <div className="flex items-center gap-4 mb-6">
                <div className="w-16 h-16 rounded-full overflow-hidden border-2 border-yellow-400 flex-shrink-0">
                  <img
                    src={review.avatar}
                    alt={review.name}
                    className="w-full h-full object-cover object-center"
                  />
                </div>
                <div>
                  <h3 className="text-lg font-bold text-white">{review.name}</h3>
                  <p className="text-sm text-gray-400">{review.role}</p>
                </div>
              </div>

              <div className="flex gap-1 mb-4">
                {[...Array(review.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-xl text-yellow-400"></i>
                ))}
              </div>

              <p className="text-gray-300 leading-relaxed">{review.comment}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}